// LLM generated - Model Claude 4 Sonnet
import { useQuery } from '@tanstack/react-query';
import { getUnreadMessages } from '../live-activity-service.service.api';
import { createQueryKey } from '~/domains/contest/domains/gamecenter/domains/common/components/ContestChat/constants/queryKeys';

type UseUnreadMessagesProps = {
  chatId?: string;
  enabled?: boolean;
};

export const useUnreadMessages = ({ chatId, enabled = true }: UseUnreadMessagesProps) =>
  useQuery({
    // Only create a valid query key when chatId is defined
    queryKey: chatId ? createQueryKey.unreadMessages(chatId) : ['unreadMessages', 'disabled'],
    queryFn: () => {
      // Safety check - if somehow called without chatId, return empty result
      // This can happen if refetch() is called before chatId is available
      if (!chatId) {
        return Promise.resolve({ data: { count: 0 } });
      }
      return getUnreadMessages(chatId);
    },
    enabled: enabled && !!chatId,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
  });
